import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { UPWORK_PROFILE } from "../../constants/links";

function AboutCard() {
  const activities = [
    "Playing Games",
    "Writing Tech Blogs",
    "Travelling",
  ];

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Aftab Ali</span> from{" "}
            <span className="purple">Bikaner, Rajasthan, India.</span>
            <br />
            I am currently employed as a Lead Software Engineer at Bacancy.
            <br />
            I am also available for freelance work on{" "}
            <a
              href={UPWORK_PROFILE}
              target="_blank"
              rel="noopener noreferrer"
              className="upwork-inline-link"
            >
              Upwork
            </a>
            .
            <br />
            I have completed Integrated BCA at MGSU Bikaner.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul style={{ padding: 0, marginTop: "1rem" }}>
            {activities.map((activity) => (
              <li key={activity} className="about-activity">
                <ImPointRight /> {activity}
              </li>
            ))}
          </ul>

          <p style={{ color: "var(--accent-purple-light)", fontStyle: "italic", marginTop: "1.5rem" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Aftab Ali</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
